<div fxLayout="column" style="padding:15px;" fxLayoutAlign="center center center">
    <mat-card ngStyle.gt-lg="width:76%;" ngStyle.lg="width:76%;" ngStyle.lt-lg="width:100%;">
        <mat-card-title>
            <app-page-header [title]="pageTitle" action=''></app-page-header>
        </mat-card-title>

        <mat-card-content>

            <div fxLayout="column" fxLayout="column" fxFlex="100" fxLayoutAlign="start start" style="margin-top:50px;">
            <div fxLayout="row" fxFlex="100" class="settingsRow" style="width: 100%; height: 250px; !important;"
                 *ngFor="let item of items"
                 fxLayoutAlign="start center center">

                <!--      <div fxFlex="10" style="width:50px; height:50px;" fxLayout="center center center">-->
                <!--        <img [src]="item.imgPath" class="settingsImage"  fxFlexAlign="center"  alt="users" style="width:50px; height:50px;"/>-->
                <!--      </div>-->

                <div fxFlex="70" fxLayout="column" class="settingsInfo" style="height:100px; margin-left:5px"
                     fxLayoutAlign="center">
                    <div fxLayout="row" style="font-size: 16px;" fxLayoutAlign="start center">
                        {{item.title}}
                    </div>
                    <div fxLayout="row" style="font-size: 10px; margin-top:10px;" fxLayoutAlign="start center">
                        {{item.description}}
                    </div>

                </div>

                <div fxFlex="30" class="settingsInfo" fxFlexAlign="center" fxLayoutAlign="end center center">
                    <button mat-raised-button style="background-color: var(--primary); color: white;"
                            (click)="navigate(item.navigationPath)">Επιλογή
                    </button>
                </div>
            </div>
            </div>
        </mat-card-content>
    </mat-card>

</div>
